export type BrandedUrl<T> = string & { __data: T };

export enum AxiosRequestConfigMethods {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

export enum OrderDirection {
  ASCENDING = "ASC",
  DESCENDING = "DESC",
}
